export const ROLE_ID = {
  SUPER: 99,
  OWNER: 2,
  REPORTER: 3,
  GLOBAL_REPORTER: 4,
};
